import Http from '../http'

export const index = (page, filters) => {
  let query = `page=${page}&filters=${filters}`
  if (filters && typeof filters === 'object') {
    Object.keys(filters).forEach(key => {
      const value = filters[key]
      if (value !== null && value !== undefined && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(val => {
            query += `&${key}=${encodeURIComponent(val)}`
          })
        } else {
          query += `&${key}=${encodeURIComponent(value)}`
        }
      }
    })
  }
  return Http.get(`/products?${query}`, {
    headers: { Authorization: localStorage.token }
  })
}

export const store = (data) =>
  Http.post('/products', { data }, { headers: { Authorization: localStorage.token } })

export const show = (id) =>
  Http.get(`/products/${id}`, { headers: { Authorization: localStorage.token } })

export const update = (id, data) => Http.patch(`/products/${id}`, { data }, { headers: { Authorization: localStorage.token } })

export const updateCategories = (data) =>
  Http.patch(
    '/products_categories/categories',
    data,
    { headers: { Authorization: localStorage.token } }
  )

export const updateMaterials = (data) =>
  Http.patch(
    '/products_materials/materials',
    data,
    { headers: { Authorization: localStorage.token } }
  )

export const updateColors = (data) =>
  Http.patch(
    '/products_colors/colors',
    data,
    { headers: { Authorization: localStorage.token } }
  )

export const updatePrice = (data) =>
  Http.patch(
    '/products_price/price',
    data,
    { headers: { Authorization: localStorage.token } }
  )

export const resetPrices = (data) =>
  Http.post(
    '/products_reset/reset-sale-prices',
    { product_ids: data }, { headers: { Authorization: localStorage.token } }
  )

export const destroy = (id) =>
  Http.delete(`/products/${id}`, { headers: { Authorization: localStorage.token } })
